import TextField from "@/common/components/TextField"

type MasterClientUserProps = {
  masterClientUser?: {
    id: string
    full_name: string
  }
}

export const MasterClientUser = ({
  masterClientUser,
}: MasterClientUserProps) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-lg">Responsável</p>
      <TextField
        label='Gestor de frota'
        name="master_user"
        value={masterClientUser?.full_name}
        disabled
      />
    </div>
  );
};
